import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";
import { AddToCard, ClearCart } from "../../../store/reducers/cart.reducer";

function LoyalMemberBox() {
  const {
    user: { loyal_member_points: lmp },
  } = useSelector((store) => store.auth);

  const dispatch = useDispatch();

  const { ApiGetLoyalMember } = useApi();

  const [form, setForm] = useState(null);
  const [loyalMemberInfo, setLoyalMemberInfo] = useState([]); // Array with all loyal member data
  const [loyalMember, setLoyalMember] = useState(null); // Loyal member data as user level user

  const getLoyalMemberInfo = useCallback(async () => {
    const { data } = await ApiGetLoyalMember();

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    data.sort((a, b) => {
      if (a.target_points < b.target_points) return -1;
      if (a.target_points > b.target_points) return 1;
      return 0;
    });

    setLoyalMemberInfo(data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getLoyalMemberInfo();

    return () => {
      dispatch(ClearCart());
    };
  }, [getLoyalMemberInfo, dispatch]);

  const findLoyalLevelUser = useCallback(() => {
    for (let i = 0; i < loyalMemberInfo.length; i++) {
      if (
        lmp >= loyalMemberInfo[i].target_points &&
        (loyalMemberInfo[i + 1] ? lmp < loyalMemberInfo[i + 1].target_points : true)
      ) {
        setLoyalMember(loyalMemberInfo[i]);
      }
    }
  }, [lmp, loyalMemberInfo]);

  useEffect(() => {
    findLoyalLevelUser();
  }, [findLoyalLevelUser, loyalMemberInfo]);

  useEffect(() => {
    console.log("loyalMember", loyalMember);
  }, [loyalMember]);

  useEffect(() => {
    if (form) {
      const payload = {
        ...form,
        loyalMember,
      };

      dispatch(AddToCard(payload));
    }
  }, [dispatch, form, loyalMember]);

  function handleSelectRadio(e) {
    setForm({ count: parseInt(e.target.value, 10), calculate: false });
  }

  function handleInputChange(e) {
    setForm({ count: parseInt(e.target.value, 10), calculate: true });
  }

  const calcPrice = useCallback((price, count) => {
    switch (count) {
      case 3: {
        price *= 0.95;
        break;
      }
      case 6: {
        price *= 0.9;
        break;
      }
      case 12: {
        price *= 0.8;
        break;
      }
      default: {
        break;
      }
    }

    return price * count;
  }, []);

  return (
    <div className="chargin-box-panel">
      {loyalMember && (
        <div className="royal-member-charging">
          <div className="royal-member-pack-box">
            <h3>
              <span className="step-counter">1</span> {t("RechargeCenter.LoyalMember.Step")}
            </h3>
            <ul className="royal-pack-list">
              {[1, 3, 6, 12].map((count) => {
                return (
                  <li>
                    <div className="pack-box">
                      <input
                        type="radio"
                        value={count}
                        name="months"
                        checked={form?.count === count && !form?.calculate}
                        id={`loyal${count}`}
                        onClick={handleSelectRadio}
                      />
                      <label for={`loyal${count}`}>
                        <div className="royal-price-box">
                          <div className="price">
                            {t("RechargeCenter.CurrencySymbol")}
                            {calcPrice(loyalMember.price, count).toFixed(2)}
                          </div>
                          <div className="price-crown">
                            <img src="images/royal-crown.png" alt="" />
                          </div>
                        </div>
                        <div className="royal-price-bot">
                          <span>{t("RechargeCenter.LoyalMember.Packages", { count })}</span>
                        </div>
                      </label>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="royal-pack-calculation">
            <div className="royal-calc-inner">
              <div className="calc-media">
                <img src="/images/royal-calc-media.png" alt="" />
              </div>
              <div className="calc-form">
                <p>{t("RechargeCenter.LoyalMember.Manual")}</p>
                <div className="input-text-group">
                  <input type="number" value={form?.calculate && form?.count} onChange={handleInputChange} />
                  <button type="submit" className="btn btn-primary">
                    {t("RechargeCenter.LoyalMember.Calculate")}
                  </button>
                  {form?.calculate && (
                    <div className="total-box">
                      <h5>
                        {t("General.Total")}{" "}
                        <span>
                          {t("RechargeCenter.CurrencySymbol")}
                          {(loyalMember.price * form?.count).toFixed(2)}
                        </span>
                      </h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <span className="or-rounded">{t("General.Or")}</span>
        </div>
      )}
    </div>
  );
}

export default LoyalMemberBox;
